import CssBaseline from '@mui/material/CssBaseline'

import ResetCSS from './ResetCSS'

const Baseline = () => {
  return (
    <>
      <CssBaseline />
      <ResetCSS />
    </>
  )
}

export default Baseline
